/**
 * Used to format numbers (using `Intl`) as strings with optional prefix or suffic.
 *
 * @example
 * {{ 123456|number }} -> 123,456
 * {{ 1234.12|number }} -> 1,234.12
 * {{ 1234.123|number(decmials=2) }} -> 1,234.12
 */
export const numberFilter = (
  number: string | number | null | undefined,
  { decimals }: { decimals?: number } = {},
) => {
  if (typeof number === 'string') {
    number = parseFloat(number)
  }
  if (typeof number === 'undefined' || number === null || isNaN(number)) {
    return ''
  }
  if (typeof decimals === 'undefined') {
    return new Intl.NumberFormat().format(number)
  }
  return new Intl.NumberFormat(undefined, {
    minimumFractionDigits: decimals,
    maximumFractionDigits: decimals,
  }).format(number)
}
